import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRating = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m18.283 5.751-3.905 7.92-8.74 1.274c-1.566.227-2.194 2.159-1.058 3.265l6.322 6.161-1.495 8.703c-.269 1.573 1.388 2.751 2.775 2.016L20 30.98l7.818 4.11c1.387.73 3.044-.443 2.775-2.016l-1.495-8.703 6.322-6.16c1.136-1.107.508-3.04-1.059-3.266l-8.739-1.274-3.905-7.92c-.7-1.411-2.728-1.43-3.434 0Z" })
});
export default SvgRating;
